import Marquee from "react-fast-marquee";

const phrases = [
  "Speed is a story",
  "Legends never idle",
  "Written in tire smoke",
  "Every engine has a voice",
  "History at full throttle",
];

export const EditorialMarquee = () => (
  <div className="border-y border-white/10 py-10 md:py-14 overflow-hidden" data-testid="editorial-marquee">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {phrases.map((p, i) => (
        <span key={i} className="flex items-center">
          <span className="font-editorial italic text-3xl md:text-5xl text-foreground/70 mx-12 md:mx-20 whitespace-nowrap">
            {p}
          </span>
          <span className="text-primary font-display text-xl md:text-2xl">/</span>
        </span>
      ))}
    </Marquee>
  </div>
);
